import React from "react";
import { useTranslation } from "react-i18next";

function RegionalRiskMap({ cardStyle }) {
const { t } = useTranslation();

return (

<div style={cardStyle}>

<h3>{t("commandCenter.regionalRiskMap.title")}</h3>

<div
style={{
display:"flex",
flexDirection:"column",
gap:"15px"
}}
>

<div
style={{
display:"flex",
justifyContent:"space-between"
}}
>
<b>{t("commandCenter.regionalRiskMap.zoneA")}</b>

<span style={{color:"#dc2626",fontWeight:"bold"}}>
{t("commandCenter.risk.CRITICAL")}
</span>
</div>

<div
style={{
display:"flex",
justifyContent:"space-between"
}}
>
<b>{t("commandCenter.regionalRiskMap.zoneB")}</b>

<span style={{color:"#f59e0b",fontWeight:"bold"}}>
{t("commandCenter.risk.WARNING")}
</span>
</div>

<div
style={{
display:"flex",
justifyContent:"space-between"
}}
>
<b>{t("commandCenter.regionalRiskMap.zoneC")}</b>

<span style={{color:"#16a34a",fontWeight:"bold"}}>
{t("commandCenter.risk.SAFE")}
</span>
</div>

<div
style={{
marginTop:"10px",
padding:"12px",
borderRadius:"10px",
background:"#1e293b",
fontWeight:"bold"
}}
>

{t("commandCenter.regionalRiskMap.multiZoneSync")}

</div>

</div>

</div>

);

}

export default RegionalRiskMap;